module.exports = __webpack_public_path__ + "static/media/home-icon.cdc4219b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/home-icon.svg
// module id = 1501
// module chunks = 0